var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-empty"},[_c('div',{ref:"noChatIcon",staticClass:"chat-empty__icon"},[_c('messages-icon')],1),_c('span',{ref:"noChatText",staticClass:"chat-empty__text"},[_vm._v(_vm._s(_vm.$t('chat.body')))])])}
var staticRenderFns = []

export { render, staticRenderFns }